module.exports = __webpack_public_path__ + "media/bootstrap-icons/bookmark-dash-7b4d0180.svg";